import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Comic_Neue%22,%22arguments%22:[{%22weight%22:[%22400%22,%22700%22],%22style%22:[%22normal%22,%22italic%22],%22subsets%22:[%22latin%22],%22display%22:%22swap%22,%22fallback%22:[%22'Comic%20Sans%20MS'%22,%22'Comic%20Sans'%22,%22cursive%22],%22preload%22:false}],%22variableName%22:%22ComicNeue%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Comic Neue', 'Comic Sans MS', 'Comic Sans', cursive",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
